/**
 * @generated SignedSource<<145ccb817328090bb54fa166ae32cbaf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ComplexMenuMobileMainNavigation_platform",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publishedLocales",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "primaryColor",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LocaleSwitch_platform"
    }
  ],
  "type": "Platform",
  "abstractKey": null
};

node.hash = "ea1087f5acb536a840288a940b8364ad";

module.exports = node;
